import React from "react";
import Reservation from "../../Component/Reservations";

export default function AllReservation({ reservationMode = "예약" }) {
  return <Reservation type="전체" reservationMode={reservationMode} />;
}
